import React, {useState, useMemo, useEffect, useCallback} from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid,Backdrop,CircularProgress, Fab } from '@material-ui/core';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { useSelector,useDispatch } from "react-redux";
import { nextPeriod, changeCurrentRoom, getScheduleAttendant, addDialogSetOpen, getPDF } from '../../redux/reducers/scheduleAttendantReducer'
import { selectRooms, getTimeZoneByRoom } from '../../redux/selectors/scheduleAttendantSelectros'
import { SheduleToolbar,SheduleDay,AddDialog, ToolbarForButton,ScrollTop } from './components';
import moment from 'moment';
import 'moment/locale/ru';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    paddingTop: '140px',
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      paddingTop: '70px',
  }
  },
  listRoot: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  test:{
    display: 'flex',
    justifyContent: 'space-between',
  },
  dayCont:{
    flex: '1 1 50%',
    border: '1px solid',
    borderColor: 'red'  
  },
  footer:{
    height: '100vh'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },

  
}));


const getPeriodString = (periodStart, periodEnd)=>{
  if ((periodEnd-periodStart)===86399) {
    return moment.unix(periodStart).format("DD MMMM YYYY");
  };

  if (moment.unix(periodStart).startOf('day').isSame(moment.unix(periodStart).startOf('month'))
      &&moment.unix(periodEnd).endOf('day').isSame(moment.unix(periodEnd).endOf('month'))) {
    return moment.unix(periodStart).format("MMMM YYYY").toUpperCase();
  }
  
  return moment.unix(periodStart).format("DD.MM.YYYY") + " - " +  moment.unix(periodEnd).format("DD.MM.YYYY");
};

const ScheduleAttendant = props => {
  const classes = useStyles();
  
  const { isFetching } = useSelector(state => state.appReducer); 
  const { periodF, schAtt, currentPeriod, currentRoom, addDialogOpen } = useSelector(state => state.schAttenReducer); 
  const dispatch = useDispatch();
  const stableDispatch = useCallback(args => {
    return dispatch(args)
  }, [dispatch]);

  const timezone = useSelector(getTimeZoneByRoom(currentRoom));

  const rooms = useSelector(selectRooms);
 
  const [openAddDialog, setOpenAddDialog] = useState(null);

  const periodString = useMemo(() => getPeriodString(currentPeriod.start, currentPeriod.end), [currentPeriod]);

  useEffect(() => {
    stableDispatch(getScheduleAttendant());
  },[stableDispatch,currentRoom]);

  const handleClickOpenAddDialog = (shift,isReplace,value={}) => {
    const param = { 
      room:currentRoom, 
      dateShift:moment.unix(shift).utcOffset(timezone).format("YYYY-MM-DD"), 
      staff:value.p, 
      timeStart:value.d1&&moment.unix(value.d1).utcOffset(timezone).format("HH:mm"), 
      timeEnd:value.d2&&moment.unix(value.d2).utcOffset(timezone).format("HH:mm"),
      isReplace,
      isEdit: Object.keys(value).length > 0
    };
    setOpenAddDialog(param);
    dispatch(addDialogSetOpen(true));
  };

  const handleCloseAddDialog = () => {
    setOpenAddDialog(false);
    dispatch(addDialogSetOpen(false));
  };

  const handleChangeRoom = (roomId) => {
    dispatch(changeCurrentRoom(roomId));
  };

  const handleChangePeriod = (periodId) => {
    dispatch(nextPeriod(0,periodId));  
  };

  const handleNextPeriod = (event) => {
    dispatch(nextPeriod(1,currentPeriod.periodId));  
  };

  const handlePrevPeriod = (event) => {
    dispatch(nextPeriod(-1,currentPeriod.periodId));  
  };

  const handlePrint = ()=> {
    dispatch(getPDF());
  }

  return (
    <div className={classes.root}>
      <Backdrop className={classes.backdrop} open={isFetching}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <div id="back-to-top-anchor"></div>
      <ToolbarForButton 
        periods={periodF}
        currentPeriodFilter={currentPeriod.periodId}
        periodString={periodString}
        onChangePeriod={handleChangePeriod}
        onClickPrint={handlePrint}
        rooms={rooms}
        currentRoom={currentRoom}
        onChangeRoom={handleChangeRoom}
        prevBtnDis={currentPeriod.prevBtnDis}
        nextBtnDis={currentPeriod.nextBtnDis}
        onClickNextPeriod={handleNextPeriod}
        onClickPrevPeriod={handlePrevPeriod}
      />
    
      {/* <SheduleToolbar
        rooms={rooms}
        currentPeriodFilter={currentPeriod.periodId}
        periods={periodF}
        periodString={periodString}
        prevBtnDis={currentPeriod.prevBtnDis}
        nextBtnDis={currentPeriod.nextBtnDis}
        currentRoom={currentRoom}
        onChangeRoom={handleChangeRoom}
        onChangePeriod={handleChangePeriod}
        onClickNextPeriod={handleNextPeriod}
        onClickPrevPeriod={handlePrevPeriod}
      />    */}

      

      <Grid container spacing={2}>
        {schAtt.length>0&&schAtt.map((value) => {
          if (value.s >= currentPeriod.start && value.s <= currentPeriod.end) {
            return (
              <Grid
                key={"grid" + value.s}
                item
                xl={3}
                lg={3}
                md={3}
                sm={6}
                xs={12}
              >
                <SheduleDay
                  shift={value.s}
                  schd={value.d}
                  timezone={timezone}
                  onClickAdd={handleClickOpenAddDialog}
                  onClickEdit={handleClickOpenAddDialog}
                />
              </Grid>
            )} else { return null };
        })}
      </Grid>
      
      <ScrollTop {...props}>
        <Fab color="primary" size="small" aria-label="scroll back to top">
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>

      {addDialogOpen
        ? <AddDialog
          open={addDialogOpen}
          init={openAddDialog}
          onClose={handleCloseAddDialog}
        />
        : null}


      <div className={classes.footer}>

      </div>

    </div>
  );
};

export default ScheduleAttendant;
